export default __webpack_public_path__ + "static/media/icon_Clock_.9ea2eae9.svg";